module.exports = __webpack_public_path__ + "components/MapControl/svg/Usługi.svg?4569d03f";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Usługi.svg
// module id = 2045
// module chunks = 0